import typeCheck from 'common/util/typeCheck';

import { SR_API_ACTION_UTILITY_PARTNER_GET_REVENUE_DETAILS } from 'api/utilityActionTypes';

export default async function getRevenueDetails(
  { state, utilityApiClient },
  { slug, forceRefresh = false },
) {
  typeCheck('slug::NonEmptyString', slug);

  const currentPartnerStatePath = ['utilityPartners', 'revenueDetailsBySlug', slug];

  if (state.get(currentPartnerStatePath) && !forceRefresh) {
    return state.get(currentPartnerStatePath);
  }

  return utilityApiClient.postWithState({
    action: SR_API_ACTION_UTILITY_PARTNER_GET_REVENUE_DETAILS,
    queryId: slug,
    state: state,
    payload: {
      slug,
    },
    onSuccess(revenueDetails) {
      if (!revenueDetails) {
        return;
      }

      state.set(currentPartnerStatePath, revenueDetails);
    },
  });
}
